import { useState, useEffect, useRef } from 'react';
import { getHojeBR } from '../utils/dataBR';
import { useDetox } from '../hooks/useDetox';
import { useBadges } from '../hooks/useBadges';
import { usePushNotifications } from '../hooks/usePushNotifications';
import { useDesafios } from '../hooks/useDesafios';
import { useJournal } from '../hooks/useJournal';
import ModalParametroInicio from '../components/desafios/ModalParametroInicio';
import DetoxEnrollment from '../components/detox/DetoxEnrollment';
import DetoxDayTrail   from '../components/detox/DetoxDayTrail';
import DetoxCheckIn    from '../components/detox/DetoxCheckIn';
import DetoxCompletion from '../components/detox/DetoxCompletion';
import ReflectionInput from '../components/journal/ReflectionInput';
import MicroCelebracao from '../components/journal/MicroCelebracao';
import DesafioAtivoCard from '../components/desafios/DesafioAtivoCard';
import FeedReflexoes from '../components/community/FeedReflexoes';
import ModalCompartilhar from '../components/community/ModalCompartilhar';
import { buscarDesafiosDaPlanilha, getConfigDesafios } from '../utils/desafios';
import { getDiaAtual, getPromptDoDia, getDatasDoDesafio } from '../utils/desafios';
import ModalCelebracao from '../components/desafios/ModalCelebracao';
import ModalParticipantes from '../components/desafios/ModalParticipantes';
import PontosToast from '../components/gamification/PontosToast';
import { supabase } from '../supabaseClient';

// SVG icons para os desafios
// eslint-disable-next-line no-unused-vars
const IconPhone = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="5" y="2" width="14" height="20" rx="2" />
    <line x1="9" y1="18" x2="15" y2="18" />
    <line x1="8" y1="8" x2="16" y2="16" />
  </svg>
);
// eslint-disable-next-line no-unused-vars
const IconFeather = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z" />
    <line x1="16" y1="8" x2="2" y2="22" />
    <line x1="17.5" y1="15" x2="9" y2="15" />
  </svg>
);
const IconHeart = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
  </svg>
);
const IconBell = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </svg>
);
const IconCheck = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);
const IconCalendar = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);
const IconChevron = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const DETOX_ID = 'detox-redes';

function ChallengeCard({ challenge, isSelected, onClick, onStartDetox, onStartSheet, onNotify, isSubscribed, notifyLoading, desafioAtivoId, iniciando }) {
  const handleNotify = (e) => { e.stopPropagation(); onNotify(); };
  const handleStart = (e) => {
    e.stopPropagation();
    if (challenge.tipo === 'detox') onStartDetox();
    else onStartSheet(challenge);
  };

  const jaAtivo = desafioAtivoId && desafioAtivoId === challenge.id && challenge.tipo !== 'detox';

  return (
    <div
      className={`challenge-card ${isSelected ? 'selected' : ''} ${challenge.active ? 'available' : ''}`}
      onClick={onClick}
    >
      <div className="challenge-card-header">
        <div className="challenge-card-left">
          <div className="challenge-icon-wrap">{challenge.icon}</div>
          <div>
            <p className="challenge-title">{challenge.title}</p>
            <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
              <span className="challenge-duration-pill">{challenge.duration}</span>
              {challenge.active && (
                <span className="challenge-available-pill">Disponível agora</span>
              )}
            </div>
          </div>
        </div>
        <div className={`challenge-chevron ${isSelected ? 'open' : ''}`}>
          <IconChevron />
        </div>
      </div>

      {isSelected && (
        <div className="challenge-card-body">
          <p className="challenge-description">{challenge.description}</p>

          {challenge.active ? (
            jaAtivo ? (
              <p className="challenge-notify-ok" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <IconCheck /> Você já está participando desse desafio
              </p>
            ) : (
              <button
                className="btn btn-primary"
                style={{ width: '100%' }}
                onClick={handleStart}
                disabled={iniciando}
              >
                {iniciando ? 'Iniciando...' : 'Começar desafio'}
              </button>
            )
          ) : (
            <>
              <p className="challenge-date" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <IconCalendar />
                {challenge._raw?.data_inicio_formatada
                  ? `Disponível a partir de ${challenge._raw.data_inicio_formatada}`
                  : 'Em breve'}
              </p>
              {isSubscribed ? (
                <p className="challenge-notify-ok" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <IconCheck /> Você já receberá notificações quando abrir!
                </p>
              ) : (
                <button
                  className="btn btn-ghost challenge-notify-btn"
                  onClick={handleNotify}
                  disabled={notifyLoading}
                >
                  {notifyLoading ? 'Ativando...' : <><IconBell /> Me avisar quando abrir</>}
                </button>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}

function ActiveDetox({ user }) {
  const {
    enrollment, checkins, communityCount,
    currentDay, todayCheckin, loading,
    enroll, checkInDay, completeChallenge, refresh,
  } = useDetox(user.id);

  const { fetchBadges, evaluateBadges } = useBadges(user.id);

  useEffect(() => { fetchBadges(); }, [user.id]); // eslint-disable-line

  const handleCheckIn = async (data) => {
    const result = await checkInDay(data);
    if (!result.error) {
      await refresh();
      if (currentDay === 7) await evaluateBadges([{ completed: true, note: 'detox' }]);
    }
    return result;
  };

  const handleComplete = async (data) => {
    const result = await completeChallenge(data);
    if (!result.error) {
      await evaluateBadges([
        ...checkins.map(c => ({ completed: true, note: c.reflection || '' })),
        { completed: true, note: 'detox_complete', date: getHojeBR() }
      ]);
    }
    return result;
  };

  if (loading) {
    return (
      <div className="loading-screen" style={{ minHeight: 120 }}>
        <div className="loading-spinner" />
      </div>
    );
  }

  if (!enrollment) {
    return <DetoxEnrollment communityCount={communityCount} onEnroll={enroll} />;
  }

  if (enrollment.completed) {
    return (
      <DetoxCompletion
        enrollment={enrollment}
        checkins={checkins}
        onComplete={handleComplete}
        alreadyCompleted={true}
      />
    );
  }

  const day7Done = checkins.some(c => c.day_number === 7);
  if (day7Done && !enrollment.completed) {
    return (
      <DetoxCompletion
        enrollment={enrollment}
        checkins={checkins}
        onComplete={handleComplete}
        alreadyCompleted={false}
      />
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div>
        <h2 style={{ marginBottom: 4 }}>
          Detox de Redes Sociais — Dia {currentDay} de 7
        </h2>
        <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, fontWeight: 300, color: 'var(--muted)' }}>
          {7 - currentDay === 0
            ? 'Último dia! Você conseguiu.'
            : `Faltam ${7 - currentDay} dia${7 - currentDay > 1 ? 's' : ''}.`}
        </p>
      </div>
      <DetoxCheckIn
        currentDay={currentDay}
        todayCheckin={todayCheckin}
        communityCount={communityCount}
        onCheckIn={handleCheckIn}
      />
      <div>
        <p className="section-title">Sua jornada</p>
        <DetoxDayTrail currentDay={currentDay} checkins={checkins} />
      </div>
    </div>
  );
}

export default function DetoxPage({ user }) {
  const [selected, setSelected] = useState(null);
  const [showDetox, setShowDetox] = useState(false);
  const [sheetChallenges, setSheetChallenges] = useState([]);
  const [loadingSheet, setLoadingSheet] = useState(true);
  const [iniciando, setIniciando] = useState(false);
  const [desafioIniciado, setDesafioIniciado] = useState(null);
  const [challengeParaIniciar, setChallengeParaIniciar] = useState(null);
  const [abaAtiva, setAbaAtiva] = useState('explorar');
  const [notaParaCompartilhar, setNotaParaCompartilhar] = useState(null);
  const [reflexaoCompartilhada, setReflexaoCompartilhada] = useState(false);
  const [mostrarMicroCelebracao, setMostrarMicroCelebracao] = useState(false);
  const [participantes, setParticipantes] = useState(null);
  const [mostrarModalParticipantes, setMostrarModalParticipantes] = useState(false);
  const [listaParticipantes, setListaParticipantes] = useState([]);
  const [mostrarCelebracao, setMostrarCelebracao] = useState(false);
  const [desafioConcluido, setDesafioConcluido] = useState(null);
  const [pontosToast, setPontosToast] = useState(null);
  const detoxRef = useRef(null);

  const { supported, isSubscribed, loading: notifyLoading, subscribe } = usePushNotifications(user.id);
  const { desafioAtivo, desafiosConcluidos, fetchDesafios, aceitarDesafio, concluirDesafio } = useDesafios(user.id);
  const { evaluateChallengeBadges, evaluateShareBadges } = useBadges(user.id);
  const { enrollment: detoxEnrollment } = useDetox(user.id);
  const { logs, todayNote, fetchData, saveNote } = useJournal(user.id);

  // Buscar desafios da planilha
  useEffect(() => {
    buscarDesafiosDaPlanilha()
      .then(data => {
        setSheetChallenges(
          data.map(d => ({
            id: d.id,
            tipo: d.id === DETOX_ID ? 'detox' : 'sheet',
            icon: <IconHeart />,
            title: d.nome,
            duration: `${d.duracao} dias`,
            description: d.descricao || '',
            active: d.ativo?.toLowerCase() === 'sim',
            _raw: d,
          }))
        );
      })
      .finally(() => setLoadingSheet(false));
    fetchDesafios();
    fetchData(user.id);
  }, [user.id]); // eslint-disable-line

  // Auto-switch para "Em andamento" se há desafio ativo ou detox em curso
  useEffect(() => {
    const temDetoxAtivo = detoxEnrollment && !detoxEnrollment.completed;
    if (desafioAtivo || temDetoxAtivo) {
      setAbaAtiva('em-andamento');
    }
  }, [desafioAtivo, detoxEnrollment]);

  // Buscar número de participantes do desafio ativo (via RPC para bypass RLS)
  useEffect(() => {
    if (!desafioAtivo?.desafio_id) return;
    supabase
      .rpc('get_desafio_participant_count', { p_desafio_id: desafioAtivo.desafio_id })
      .then(({ data }) => { if (data !== null) setParticipantes(Number(data)); });
  }, [desafioAtivo?.desafio_id]); // eslint-disable-line

  const handleVerParticipantes = async () => {
    const { data } = await supabase
      .rpc('get_desafio_participantes', { p_desafio_id: desafioAtivo.desafio_id });
    setListaParticipantes(data || []);
    setMostrarModalParticipantes(true);
  };

  const allChallenges = sheetChallenges;

  // Prompt do dia do desafio ativo
  const diaInfo = desafioAtivo ? getDiaAtual(desafioAtivo.data_inicio, desafioAtivo.duracao) : null;
  const promptDesafio = diaInfo?.diaAtual
    ? desafioAtivo?.prompts?.[`prompt_dia_${diaInfo.diaAtual}`]
    : null;

  const handleSaveNote = async (note) => {
    const result = await saveNote(note);
    if (!result.error && note?.trim().length > 0) {
      await fetchData(user.id);
      setNotaParaCompartilhar(note.trim());
      setMostrarMicroCelebracao(true);

      // Verificar se todos os dias do desafio têm reflexão
      if (desafioAtivo) {
        const datas = getDatasDoDesafio(desafioAtivo.data_inicio, desafioAtivo.duracao);
        const today = getHojeBR();
        const logsMap = {};
        logs.forEach(l => { logsMap[l.date] = !!(l.note?.trim()); });
        logsMap[today] = !!(note?.trim()); // inclui nota recém salva (logs ainda não atualizados)
        const diasEscritos = datas.filter(d => logsMap[d]).length;

        if (diasEscritos >= desafioAtivo.duracao) {
          const { error: errConcluir } = await concluirDesafio();
          if (!errConcluir) {
            await evaluateChallengeBadges(desafioAtivo.desafio_id, desafiosConcluidos.length + 1);
            setDesafioConcluido({ ...desafioAtivo });
            setMostrarCelebracao(true);
          }
        }
      }
    }
    return result;
  };

  const handleCardClick = (challenge) => {
    if (selected === challenge.id) {
      setSelected(null);
    } else {
      setSelected(challenge.id);
    }
    setDesafioIniciado(null);
  };

  const handleStartDetox = () => {
    setShowDetox(true);
    setAbaAtiva('em-andamento');
    setTimeout(() => {
      detoxRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  };

  const handleStartSheet = (challenge) => {
    // Se tem parâmetro configurado, abre modal antes de iniciar
    if (challenge._raw?.parametro_pergunta_antes && challenge._raw?.parametro_opcoes) {
      setChallengeParaIniciar(challenge);
    } else {
      confirmarInicioDesafio(challenge, null);
    }
  };

  const confirmarInicioDesafio = async (challenge, parametroAntes) => {
    setChallengeParaIniciar(null);
    setIniciando(true);
    const raw = challenge._raw;
    const { error } = await aceitarDesafio({
      id: raw.id,
      nome: raw.nome,
      duracao: raw.duracao,
      frase_inspiradora: raw.frase_inspiradora || '',
      titulo_reflexao: raw.titulo_reflexao || '',
      prompts: raw.prompts || {},
      parametro_label: raw.parametro_label || '',
      parametro_pergunta_antes: raw.parametro_pergunta_antes || '',
      parametro_pergunta_depois: raw.parametro_pergunta_depois || '',
      parametro_opcoes: raw.parametro_opcoes || '',
    }, parametroAntes);
    setIniciando(false);
    if (!error) {
      setDesafioIniciado(challenge.id);
      setAbaAtiva('em-andamento');
      setPontosToast({ pontos: 10, label: 'novo desafio iniciado!' });
      if (window.fbq) window.fbq('trackCustom', 'DesafioIniciado', { desafio: raw.nome });
    }
  };

  const handleNotify = async () => {
    if (!supported) {
      alert('Notificações não são suportadas neste navegador. Adicione o app à tela inicial do seu iPhone e abra por lá.');
      return;
    }
    await subscribe();
  };

  const temDetoxAtivo = (detoxEnrollment && !detoxEnrollment.completed) || showDetox;
  const temAlgoAtivo = desafioAtivo || temDetoxAtivo;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {/* Título da seção */}
      <div style={{ padding: '0 24px' }}>
        <h1 style={{ color: 'var(--navy)', marginBottom: getConfigDesafios().descricao ? 6 : 0 }}>Desafios</h1>
        {getConfigDesafios().descricao && (
          <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', margin: 0, lineHeight: 1.5 }}>
            {getConfigDesafios().descricao}
          </p>
        )}
      </div>

      {/* Sub-abas */}
      <div className="desafios-abas">
        <button
          className={`desafios-aba-btn ${abaAtiva === 'em-andamento' ? 'ativo' : ''}`}
          onClick={() => setAbaAtiva('em-andamento')}
        >
          Em andamento
        </button>
        <button
          className={`desafios-aba-btn ${abaAtiva === 'explorar' ? 'ativo' : ''}`}
          onClick={() => setAbaAtiva('explorar')}
        >
          Explorar
        </button>
      </div>

      {/* ── Aba: Em andamento ── */}
      {abaAtiva === 'em-andamento' && (
        <>
          {!temAlgoAtivo ? (
            <div className="section desafios-vazio">
              <p className="desafios-vazio-texto">Você não tem nenhum desafio ativo no momento.</p>
              <button className="btn btn-primary" onClick={() => setAbaAtiva('explorar')}>
                Explorar desafios
              </button>
            </div>
          ) : (
            <>
              {/* Sheet challenge ativo */}
              {desafioAtivo && !diaInfo?.concluido && (
                <>
                  {participantes !== null && (
                    <button
                      className="desafio-participantes-destaque"
                      onClick={handleVerParticipantes}
                      style={{ cursor: 'pointer', background: 'none', border: 'none', padding: 0, width: '100%', textAlign: 'left' }}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
                        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                      </svg>
                      <span>{participantes} {participantes === 1 ? 'pessoa participando' : 'pessoas participando'}</span>
                    </button>
                  )}
                  <div className="section">
                    <div className="card desafio-card-unificado">
                      <DesafioAtivoCard desafio={desafioAtivo} logs={logs} embedded />
                      <div className="desafio-card-divider" />
                      <ReflectionInput
                        initialNote={todayNote}
                        onSave={handleSaveNote}
                        titulo={desafioAtivo.titulo_reflexao || desafioAtivo.desafio_nome}
                        prompt={promptDesafio || getPromptDoDia()}
                        embedded
                        lockAfterSave={reflexaoCompartilhada || !!todayNote}
                      />
                    </div>
                  </div>
                  <div className="section">
                    <p className="section-title">O que a comunidade compartilhou</p>
                    <FeedReflexoes userId={user.id} />
                  </div>
                </>
              )}

              {/* Detox ativo */}
              {temDetoxAtivo && (
                <div className="section" ref={detoxRef}>
                  {desafioAtivo && <p className="section-title">Detox de Redes Sociais</p>}
                  <ActiveDetox user={user} />
                </div>
              )}
            </>
          )}
        </>
      )}

      {/* ── Aba: Todos ── */}
      {abaAtiva === 'explorar' && (
        <div className="section">
          <h1 style={{ marginBottom: 6, color: 'var(--navy)' }}>Todos os desafios</h1>
          <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 14, fontWeight: 300, color: 'var(--muted)', lineHeight: 1.6, marginBottom: 20 }}>
            Escolha um desafio e comprometa-se com sua transformação.
          </p>

          {desafioIniciado && (
            <div className="desafio-iniciado-banner">
              <IconCheck />
              <span>Desafio iniciado! Vá para "Em andamento" para começar sua reflexão.</span>
            </div>
          )}

          <div className="challenge-list">
            {loadingSheet && sheetChallenges.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '48px 0' }}>
                <div className="loading-spinner" style={{ margin: '0 auto' }} />
              </div>
            ) : (
              allChallenges.map(c => (
                <ChallengeCard
                  key={c.id}
                  challenge={c}
                  isSelected={selected === c.id}
                  onClick={() => handleCardClick(c)}
                  onStartDetox={handleStartDetox}
                  onStartSheet={handleStartSheet}
                  onNotify={handleNotify}
                  isSubscribed={isSubscribed}
                  notifyLoading={notifyLoading}
                  desafioAtivoId={desafioAtivo?.desafio_id}
                  iniciando={iniciando}
                />
              ))
            )}
          </div>
        </div>
      )}

      {/* Modais */}
      {challengeParaIniciar && (
        <ModalParametroInicio
          desafio={challengeParaIniciar._raw}
          onConfirmar={(parametroAntes) => confirmarInicioDesafio(challengeParaIniciar, parametroAntes)}
          onCancelar={() => setChallengeParaIniciar(null)}
        />
      )}

      {notaParaCompartilhar && (
        <ModalCompartilhar
          nota={notaParaCompartilhar}
          desafioAtivo={desafioAtivo}
          userId={user?.id}
          onFechar={(shared) => {
            setNotaParaCompartilhar(null);
            if (shared) {
              setReflexaoCompartilhada(true);
              evaluateShareBadges();
              setPontosToast({ pontos: 30, label: 'reflexão compartilhada!' });
            }
          }}
        />
      )}

      {mostrarMicroCelebracao && (
        <MicroCelebracao
          streak={0}
          onFim={() => setMostrarMicroCelebracao(false)}
        />
      )}

      {mostrarModalParticipantes && (
        <ModalParticipantes
          participantes={listaParticipantes}
          onFechar={() => setMostrarModalParticipantes(false)}
        />
      )}

      {mostrarCelebracao && desafioConcluido && (
        <ModalCelebracao
          desafio={desafioConcluido}
          conquista={null}
          onFechar={() => { setMostrarCelebracao(false); setDesafioConcluido(null); }}
        />
      )}

      {pontosToast && (
        <PontosToast
          pontos={pontosToast.pontos}
          label={pontosToast.label}
          onDismiss={() => setPontosToast(null)}
        />
      )}
    </div>
  );
}
